import { render, staticRenderFns } from "./ForgotPasswordSuccessModal.vue?vue&type=template&id=883f7b7c"
import script from "./ForgotPasswordSuccessModal.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordSuccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports